import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import p from "../../../package.json";
import { getSystemInfo } from "../../api/services/system";
import {
    Page,
    PageLoader,
    PageHeader,
    KeyValueList,
    Badge,
    Card,
    CardTitle,
    CardContent,
    Row,
    Col
} from "@tv2no/ui-react";
import config from "../../config";

export const SystemInfo = () => {
    const [system, setSystem] = useState(null);

    useEffect(() => {
        getSystemInfo().then((res) => setSystem(res));
    }, []);

    return system ? (
        <Page>
            <PageHeader title="Systeminfo" subtitle="Skattelister" icon="info" />
            <Row>
                <Col span={24}>
                    <Card>
                        <CardTitle title="Web-app" />
                        <CardContent>
                            <KeyValueList align="left">
                                <KeyValueList.Item label="Miljø">
                                    <Badge fill>{config.appEnv}</Badge>
                                </KeyValueList.Item>
                                <KeyValueList.Item label="Versjon">
                                    <Badge>{p.version}</Badge>
                                </KeyValueList.Item>
                                <KeyValueList.Item label="Bygget">
                                    {dayjs(Number(config.buildTime)).format("LLL")}
                                </KeyValueList.Item>
                            </KeyValueList>
                        </CardContent>
                    </Card>
                </Col>
                <Col span={24}>
                    <Card>
                        <CardTitle title="API" />
                        <CardContent>
                            <KeyValueList align="left">
                                <KeyValueList.Item label="Navn">{system.name}</KeyValueList.Item>
                                <KeyValueList.Item label="Miljø">
                                    <Badge fill>{system.environment}</Badge>
                                </KeyValueList.Item>
                                <KeyValueList.Item label="Versjon">
                                    <Badge>{system.buildVersion}</Badge>
                                </KeyValueList.Item>
                                <KeyValueList.Item label="Bygget">
                                    {dayjs(
                                        parseInt(
                                            system.buildTime.toString().replaceAll(".", ""),
                                            10
                                        )
                                    ).format("LLL")}
                                </KeyValueList.Item>
                            </KeyValueList>
                        </CardContent>
                    </Card>
                </Col>
                <Col span={24}>
                    <Card>
                        <CardTitle title="Utviklere" />
                        <CardContent>
                            <KeyValueList align="left">
                                {system.developers &&
                                    system.developers.map((developer, index) => (
                                        <KeyValueList.Item key={index} label={developer.name}>
                                            {developer.email}
                                        </KeyValueList.Item>
                                    ))}
                            </KeyValueList>
                        </CardContent>
                    </Card>
                </Col>
            </Row>
        </Page>
    ) : (
        <PageLoader />
    );
};
